import * as dat from "lil-gui";
var Debug = /** @class */ (function () {
    function Debug() {
        this.isActive = window.location.hash === "#debug";
        if (this.isActive) {
            this.gui = new dat.GUI();
        }
    }
    return Debug;
}());
export default Debug;
